var _excluded = ["href", "_noHref", "type"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Anchor as CoreAnchor } from '@kizi/core-components';
import React from 'react';
export var Anchor = function Anchor(_ref) {
  var href = _ref.href,
      _ref$_noHref = _ref._noHref,
      _noHref = _ref$_noHref === void 0 ? false : _ref$_noHref,
      type = _ref.type,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var hrefValue = href || '/';
  var isHrefExternal = hrefValue.startsWith('http');

  if (type === 'mail') {
    hrefValue = "mailto:".concat(href);
  } else if (type === 'phone' || type === 'emergency_phone') {
    hrefValue = "tel:".concat(href);
  } else if (type === 'website') {
    hrefValue = "".concat(href);
  } else if (type === 'whatsapp') {
    hrefValue = "https://api.whatsapp.com/send?phone=".concat(href);
  }

  return /*#__PURE__*/React.createElement(CoreAnchor, _extends({
    "data-testid": type,
    style: {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    href: hrefValue,
    target: isHrefExternal ? '_blank' : '_self'
  }, restProps));
};